import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canViewPasskeys } from '../permissions';

export const useSettingsPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canViewPasskeys: bindViewer(canViewPasskeys),
    }),
    [bindViewer],
  );
};
